import getConfig from 'next/config';
import '@firebase/auth';
import { Firestore, getFirestore } from '@firebase/firestore';
import { FirebaseApp, getApp, initializeApp } from '@firebase/app';

class FirebaseService {
  private database: Firestore | undefined;
  public app: FirebaseApp | undefined;

  constructor(firebaseConfig: any) {
    try {
      this.app = getApp();
    } catch (error) {
      if (typeof window !== 'undefined') {
        this.app = initializeApp(firebaseConfig);
      }
    }

    if (this.app) {
      this.database = getFirestore(this.app);
    }
  }

  public get db() {
    if (!this.database) {
      throw new Error('Firebase database not initialized');
    }

    return this.database;
  }
}

const {
  publicRuntimeConfig: { firebaseConfig },
} = getConfig();

export default new FirebaseService(firebaseConfig);
